import { render } from "./PackageSpecCard.vue?vue&type=template&id=7e7c9025&scoped=true"
import script from "./PackageSpecCard.vue?vue&type=script&lang=js"
export * from "./PackageSpecCard.vue?vue&type=script&lang=js"

import "./PackageSpecCard.vue?vue&type=style&index=0&id=7e7c9025&lang=scss&scoped=true"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7c9025"]])

export default __exports__